module.exports = {
  "zones": {
    "Asia/Dushanbe": ["z", {
      "wallclock": 684385200000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": 684363600000,
      "save": 0
    }, {
      "wallclock": 670384800000,
      "format": "+05/+06",
      "abbrev": "+06",
      "offset": 18000000,
      "posix": 670363200000,
      "save": 3600000
    }, {
      "wallclock": -1247529600000,
      "format": "+06/+07",
      "abbrev": "+06",
      "offset": 21600000,
      "posix": -1247547600000,
      "save": 0,
      "rules": "RussiaAsia"
    }, {
      "wallclock": -1441152000000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": -1441168512000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 16512000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "RussiaAsia": [{
      "from": 1985,
      "to": 2010,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2010,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1981,
      "to": 1983,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};